module.exports = __webpack_public_path__ + "static/media/SAMAT.a4470002.png";